import Vue from 'vue';

const issueablesEventBus = new Vue();

export default issueablesEventBus;
